/**
 * admin.js  — Admin API calls (all require admin JWT)
 */
import api from './auth';

export async function adminListUsers() {
  const { data } = await api.get('/admin/users');
  return data;
}

export async function adminLockUser(userAccountId) {
  const { data } = await api.put(`/admin/users/${userAccountId}/lock`);
  return data;
}

export async function adminUnlockUser(userAccountId) {
  const { data } = await api.put(`/admin/users/${userAccountId}/unlock`);
  return data;
}

export async function adminDeactivateUser(userAccountId) {
  const { data } = await api.put(`/admin/users/${userAccountId}/deactivate`);
  return data;
}

export async function adminGetAiUsage(params = {}) {
  const { data } = await api.get('/admin/ai-usage', { params });
  return data;
}

export async function adminLoadVehicleConfig(configArray) {
  const { data } = await api.post('/admin/vehicle-config', configArray);
  return data;
}

export async function adminAiVehicleConfig(make, model, yearFrom, yearTo) {
  const { data } = await api.post('/admin/vehicle-config/ai', { make, model, yearFrom, yearTo });
  return data;
}
